<template>
    <div :class="footFlag ? 'foot1' : 'foots'" ref="foot">
        <div class="sureButton">
            <el-button v-if="actionType == 2 && $common.checkIsPrint() && flag" type="primary" @click="showPrintPlan">打印</el-button>
            <el-button v-if="actionType != 2" @click.stop="initActionBox('sendDataInfo')">取消</el-button>
            <el-button v-if="closeFlag" @click.stop="initActionBox('sendDataInfo')">取消</el-button>
            <el-button style="margin-left: 50px !important;" v-if="actionType != 2" type="primary" @click.stop="sendDataAction('sendDataInfo')">保存</el-button>
            <el-link v-if="btnFlag&&actionType!=2" :underline="false" type="danger" style="margin-left: 10px;font-size: 16px;">
                (F4：保存)</el-link>
            <slot name="btn"></slot>

        </div>
        <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
            <template v-for="(itemV, itemK) in footForm">
                <el-form-item :label="itemV.chineseField" v-if="itemV.isShow==1" :key="itemK">
                    <span type="success" class="number">{{ sendDataInfo[itemV.entityField] }}</span>
                </el-form-item>
            </template>
        </el-form>

    </div>
</template>

<script>
export default {
    name: "vFoot",
    props: {
        sendDataInfo: {
            type: Object,
            default: () => {
                return {}
            }
        },
        actionType: {
            type: Number,
            default: () => {
                return 0
            }
        },
        footForm: {
            type: Array,
            default: () => {
                return []
            }
        },
        footFlag: {
            type: Boolean,
            default: () => {
                return true
            }
        },
        flag: {
            type: Boolean,
            default: () => {
                return true
            }
        },
        btnFlag: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        closeFlag: {
            type: Boolean,
            default: () => {
                return false
            }
        },
    },
    data() {
        return {
        }
    },
    methods: {
        initActionBox(val) {
            this.$emit('initActionBox', val)
        },
        showPrintPlan() {
            this.$emit('showPrintPlan')
        },
        sendDataAction(val) {
            this.$emit('sendDataAction', val)
        },
    },
}
</script>

<style scoped>
.foot1 {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    width: 100%;
    background: #fff;
    height: 46px;
    padding: 5px 10px;
    z-index: 999;
    position: fixed;
    bottom: 0;
    left: 0;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
.sureButton {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.number {
    color: red;
    font-size: 18px !important;
    background: none;
    border: none;
}
</style>